import { ArtifactGenerator } from './ArtifactGenerator';

export class PRFAQGenerator extends ArtifactGenerator {
  generatePrompt(): string {
    return `You are an expert Amazon-style PRFAQ writer. 
    I will provide a set of product or service ideas below, and I’d like you to 
    produce a comprehensive PRFAQ document. The PRFAQ should follow Amazon’s 
    internal style guidelines: it should read like a press release followed by 
    a FAQ section and appendices.

Context and Ideas:

The product/service is based on the following ideas: 

${this.getIdeaHierarchy()}

Structure of the Document:

Press Release Section:
Press release section should be a narrative. Avoid bullet points. The narrative 
should flow through multiple paragraphs. This section should be 1.5 pages.

Write a compelling headline and sub-headline that clearly state the product’s 
purpose and its groundbreaking nature.

The opening paragraphs should introduce the product, explain who it’s for, and 
why it matters. Include any planned launch date or timeframe.

Highlight at least 5 top features, presented as narrative, that set this product 
apart.

Include 3-4, compelling customer or early adopter testimonials. Each should be 
3 sentences long.

Include a two quotes from the leadership team or product creators that showcases the vision and long-term goals.

FAQ Section (15-20 Questions):
Include a mix of:
External customer questions about functionality, support, pricing, and privacy.
Internal stakeholder questions about roadmap, scalability, and integrations.
Several “rude” or skeptical questions from a tough journalist or skeptical customer.
Provide clear, confident answers that remain honest and realistic.
Appendices:
Appendix A: Technical Implementation Details (architecture, tech stack, security measures)
Appendix B: Detailed User Flow & Onboarding Steps
Appendix C: Market Research & Competitive Analysis
Appendix D: Future Roadmap & Growth Plans
Style and Tone:

The press release should be accessible, exciting, and journalistic.
The FAQ answers should be direct, transparent, and helpful. Even when addressing rude questions, remain respectful and factual.
The appendices can be more technical and detailed.
Formatting & Length:

Approximately 2-3 pages for the PR and FAQ sections combined.
1-2 pages for appendices, as needed.
Now, using these instructions and the provided ideas, please produce the final Amazon-style PRFAQ document.
`;
  }

  protected getIdeaHierarchy(): string {
    return this.ideas.map((idea, index) => {
      return `### Idea ${index + 1}: ${idea.content}
${idea.children.map(child => `- ${child.content}`).join('\n')}`;
    }).join('\n\n');
  }
}
